import { compose, lifecycle, withState, withHandlers } from 'recompose';
import { connect } from 'react-redux';

export default compose(
  connect(
    ({ alert: { message } }) => ({
      message
    }),
    null
  ),
  withState('passwordError', 'setPasswordError', ''),
  withState('buttonText', 'setButtonText', 'UPDATE'),
  withState('submitting', 'setSubmitting', false),
  withHandlers({
    validatePassword: () => ({ password, passwordConfirm }) => {
      if (password) {
        if (
          password.length < 8 ||
          !password.match(/[A-Z]+/) ||
          !password.match(/[a-z]+/) ||
          !password.match(/[!@#$%^&*)(+=._\-[\]]+/)
        ) {
          return {
            password:
              'Password must contain a minimum of 8 characters, 1 uppercase, 1 lowercase and 1 special character'
          };
        } else if (password !== passwordConfirm) {
          return { passwordConfirm: 'Password confirmation does not match password' };
        }
      }

      return {};
    },
    handleOnSubmit: ({ onSubmit, setButtonText, message, setSubmitting, clearMessage }) => (
      { password },
      { change },
      callback
    ) => {
      setButtonText('UPDATING...');
      setSubmitting(true);
      clearMessage();
      onSubmit({
        new_password: password,
        onFailure: () => {
          change('password', '');
          change('passwordConfirm', '');
          callback({ password: (message && message.text) || 'NewPasswordError' });
        }
      });
    }
  }),
  lifecycle({
    componentWillUpdate(nextProps) {
      if (nextProps.message && nextProps.message !== this.props.message) {
        this.props.setButtonText('UPDATE');
        this.props.setSubmitting(false);
      }
    }
  })
);



// WEBPACK FOOTER //
// ./src/views/common/containers/NewPasswordEnhancer/index.js